module.exports = __webpack_public_path__ + "img/icon-warning.30cbdb1d.png";